import pptxgen from "pptxgenjs";
import { useCallback, useEffect, useRef, useState } from "react";
import Theme from "../../assets/images/2PPT1stpage.jpeg";
import logo from "../../assets/images/Logo.png";
import lastPPT from "../../assets/images/2PPT4thpage.jpeg";
import termsImgPPT from "../../assets/images/2PPT3rdpage.jpeg";
import whiteLayout from "../../assets/images/2PPT2ndpage.jpeg";
import { Button, Col, Row, Modal, ModalBody } from "reactstrap";
import { FilterSelection } from "../FilterSelection/FilterSelection.jsx";
import "./DownloadFiles.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { MediumList } from "../../constants/data";
import { FaDownload } from "react-icons/fa";
import { Header } from "../../components/Header/Header.jsx";
import { routes } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { Pagination } from "@mui/material";
import { useDispatch } from "react-redux";
import { setLoadingTrue, setLoadingFalse } from "../../redux/slices/loaderSlice.js";

import ExcelJS from "exceljs";
import Loader from "../../components/Loader/Loader.jsx";

export default function DownloadFiles({ loading, setOpenModal, setShowAlert }) {

  const storedUserDetails = localStorage.getItem("user_details");
  const user_details = JSON.parse(storedUserDetails);
  const dispatch = useDispatch();
  const [PPTdata, setPPTdata] = useState([]);
  const [pagePPTdata, setPagePPTdata] = useState([]);
  const [medium, setMedium] = useState("1");
  const [checkbox, setCheckbox] = useState({ 0: false });
  const [imgModal, setImgModal] = useState(false);
  const [page, setPage] = useState(1);
  const [total_page_count, setTotal_page_count] = useState(1);
  const [imgURL, setImgURL] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [showRate, setShowRate] = useState(localStorage.getItem("ratePercentage") ? localStorage.getItem("ratePercentage") : "noRate");
  const [processingProgress, setProcessingProgress] = useState({ current: 0, total: 0, isProcessing: false });

  const [showLatitude, setShowLatitude] = useState(localStorage.getItem("showLatitude"));
  const navigate = useNavigate();
  const myRef = useRef(null);
  let showDataBelowImage = localStorage.getItem("showDataBelowImage");

  const handleCheck = (n) => {
    const checked = !checkbox[n];
    setCheckbox({ ...checkbox, [n]: checked });
  };

  const generatePPT = async () => {
    dispatch(setLoadingTrue());
    let data = [];
    for (let i = 0; i < PPTdata.length; i++) {
      if (checkbox[i] === true) {
        data.push(PPTdata[i]);
      }
    }
    
    // Initialize progress tracking
    setProcessingProgress({ current: 0, total: data.length, isProcessing: true });
    const d1 = new Date();
    const d = d1.toString();
    const date = `${d.slice(8, 10)} ${d.slice(4, 7)}, ${d1.getFullYear()}`;
    const showTime = d1.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    try {
      let pres = new pptxgen();
      pres.layout = "LAYOUT_16x9";
      let slide1 = pres.addSlide();
      slide1.addImage({
        path: Theme,
        x: "0%",
        y: "0%",
        w: "100%",
        h: "100%",
      });
      slide1.addText(date,{
        x: 8.8,
        y: 5.25,
        bold: "true",
        fontSize: "12",
        color:'#FFFFFF'
      })
      slide1.addText(showTime, {
        x: 8.8,
        y: 5.5,
        bold: "true",
        fontSize: "12",
        color:'#FFFFFF'
      });
      

      pres.defineSlideMaster({
        title: "MASTER_SLIDE",
        objects: [
          {
            image: {
              path: whiteLayout,
              x: 0,
              y: 0,
              w: "100%",
              h: "100%",
            },
          },
        ],
      });

      // Helper function to preload image and convert to base64
      const loadImageAsBase64 = (imageUrl) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          
          img.onload = () => {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const base64 = canvas.toDataURL('image/jpeg', 0.8);
              resolve(base64);
            } catch (error) {
              console.log('Canvas conversion failed, using URL:', error);
              resolve(imageUrl); // Fallback to original URL
            }
          };
          
          img.onerror = () => {
            console.log('Image load failed, using URL as fallback');
            resolve(imageUrl); // Fallback to original URL
          };
          
          img.src = imageUrl;
        });
      };

      // Process images sequentially to avoid resource exhaustion
      let slides = [];
      const batchSize = 5; // Process 5 images at a time
      
      for (let i = 0; i < data.length; i += batchSize) {
        const batch = data.slice(i, i + batchSize);
        
        // Process current batch
        await Promise.all(batch.map(async (item, batchIndex) => {
          const actualIndex = i + batchIndex;
          console.log(`Processing image ${actualIndex + 1} of ${data.length}`);
          
          // Update progress
          setProcessingProgress(prev => ({ ...prev, current: actualIndex + 1 }));
          
          slides[actualIndex] = pres.addSlide({ masterName: "MASTER_SLIDE" });

          let y1 = 0.00;
          if(showDataBelowImage !== "true"){
            y1 = 0.35;
          }
          
          try {
            // Load image as base64 to avoid resource conflicts
            const imageData = await loadImageAsBase64(item.image);
            
            slides[actualIndex].addImage({
              data: imageData,
              x: 1.2,
              y: y1,
              w: "74%",
              h: "84%",
            });
          } catch (e) {
            console.log("----e", e);
            setShowAlert({open: true, message: `Failed to load image ${item.idno}: ${e.message}`});
            
            // Add a placeholder or skip the image
            try {
              slides[actualIndex].addText("Image failed to load", {
                x: 1.2,
                y: y1 + 2,
                w: "74%",
                h: "10%",
                fontSize: "16",
                color: "#FF0000",
                align: "center"
              });
            } catch (textError) {
              console.log("Failed to add error text:", textError);
            }
          }
          
          let locationText = `${item.idno} - ${item.location?.length > 60 ? (item.location?.slice(0, 60)+ "... ") : item.location}`;
          if(medium === "1" || medium === "5"){
            locationText = `${locationText}, ${item.width} x ${item.height}, ${item.type}`;
          }
          
          if ((medium === "1" || medium === "5") && showLatitude !== "false" && showDataBelowImage === "true") {
            let arrTabRows = [
              [
                { text: locationText, options: { colspan: 2, fontSize: "10" } }
              ],
              [
                { text: `   Availability:     ${item.availability}` },
                { text: `   Rate:     ${showRate !== "noRate" ? item.rate : ""}` }
              ],
              [
                { text: `   Lat & Long:   ` },
                { text: `   Note:  ` }
              ]
            ];
            
            slides[actualIndex].addTable(arrTabRows, {
              x: 1.21,
              y: 4.73,
              w: "74%",
              h: 0.7,
              colW: [3.69, 3.69],
              color: "#FFFFFF",
              fontSize: "12",
              border: { type: "solid", pt: "3", color: "#000000" },
            });
          } else if (showDataBelowImage === "true") {
            let arrTabRows = [
              [
                { text: locationText , options: { colspan: 2, fontSize: "10" } }
              ],
              [
                { text: `   Availability:     ${item.availability}` },
                {
                  text: `   Rate:     ${showRate !== "noRate" ? item.rate : ""}`,
                },
              ],
            ];
            slides[actualIndex].addTable(arrTabRows, {
              x: 1.21,
              y: 4.73,
              w: "74%",
              h: 0.35,
              colW: [3.69, 3.69],
              color: "#FFFFFF",
              fontSize: "12",
              border: { type: "solid", pt: "3", color: "#000000" },
            });
          }
          
          if ((medium === "1" || medium === "5") && showLatitude !== "false" && showDataBelowImage === "true"){
            slides[actualIndex].addText(`${item.latitude} & ${item.longitude}`, {
              hyperlink: {
                url: `https://www.google.com/maps/place/${item.latitude},${item.longitude}`,
                tooltip: "Location",
              },
              x: 2.25,
              y: 5.475,
              color: "363636",
              bold: "true",
              fontSize: "12",
            });
          }
        }));
        
        // Small delay between batches to prevent overwhelming the browser
        if (i + batchSize < data.length) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
      pres.defineSlideMaster({
        title: "MASTER2",
        objects: [
          {
            image: {
              path: termsImgPPT,
              x: 0,
              y: 0,
              w: "100%",
              h: "100%",
            },
          },
        ],
      });
      let termsSlide = pres.addSlide({ masterName: "MASTER2" });
      termsSlide.background = {
        fill: "000000",
      };
      pres.defineSlideMaster({
        title: "MASTER3",
        objects: [
          {
            image: {
              path: lastPPT,
              x: 0,
              y: 0,
              w: "100%",
              h: "100%",
            },
          },
        ],
      });
      let lastSlide = pres.addSlide({ masterName: "MASTER3" });
      lastSlide.addText(
        `${user_details.first_name} ${user_details.last_name} | ${user_details.designation_name}`,
        {
          x: 5,
          y: 2.7,
          w: 3,
          h: 0.3,
          fontSize: "12",
          color: "#FFFFFF",
          bold: true,
        }
      );
      lastSlide.addText(user_details.mobile, {
        x: 5.4,
        y: 2.95,
        w: 3,
        h: 0.3,
        fontSize: "12",
        color: "#FFFFFF",
        bold: true,
      });
      lastSlide.addText(user_details.email, {
        x: 5.4,
        y: 3.25,
        w: 3,
        h: 0.3,
        fontSize: "12",
        color: "#FFFFFF",
        bold: true,
      });
      lastSlide.addText(" ", {
        x: 4.35,
        y: 4.38,
        w: 0.33,
        h: 0.25,
        color: "#000000",
        hyperlink: {
          url: "https://www.facebook.com/kaushikoutdoors",
        },
      });

      lastSlide.addText(" ",{
        x: 4.6,
        y: 4.38,
        w: 0.33,
        h: 0.25,
        hyperlink: {
          url: "https://www.linkedin.com/company/kaushik-outdoors/",
        },
      });

      lastSlide.addText(" ",{
        x: 4.85,
        y: 4.38,
        w: 0.33,
        h: 0.25,
        hyperlink: {
          url: "https://www.instagram.com/kaushikoutdoors/",
        },
      });

      lastSlide.addText(" ",{
        x: 5.05,
        y: 4.38,
        w: 0.33,
        h: 0.25,
        hyperlink: {
          url: "https://www.youtube.com/@kaushikoutdoors1812",
        },
      });

      lastSlide.addText(" ",{
        x: 5.3,
        y: 4.38,
        w: 0.35,
        h: 0.25,
        hyperlink: {
          url: "https://www.facebook.com/kaushikoutdoors",
        },
      });

      pres
        .writeFile({
          fileName: `Presentation_${d.slice(0, 24).replace(/ /g, "_")}.pptx`,
        })
        .then((s) => {
          // console.log("first", s);
          setProcessingProgress({ current: 0, total: 0, isProcessing: false });
          dispatch(setLoadingFalse());
        })
        .catch((e) => {
          console.log(e);
          setShowAlert({open: true, message:e.message})
          setProcessingProgress({ current: 0, total: 0, isProcessing: false });
          dispatch(setLoadingFalse());
        });
    } catch (e) {
      console.log("----e", e);
      setShowAlert({open: true, message:e.message})
      setProcessingProgress({ current: 0, total: 0, isProcessing: false });
      dispatch(setLoadingFalse());
      // reload after 1 second
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const getHeading = () => {
    let h = [];
    if (medium === "1" || medium === "5") {
      h = [
        [
          "SR NO",
          "ID NO",
          "ZONE",
          "CITY/AREA",
          "LOCATION",
          "MEDIA",
          "TYPE",
          "WIDTH",
          "HEIGHT",
          "AVAILABILITY",
        ],
      ];
      if (showLatitude !== "false") {
        // console.log("first", 393);
        h[0] = h[0].concat(["LONGITUDE & LATITUDE"]);
      }
    }
    if (medium === "2") {
      h = [
        ["SR NO", "ID NO", "AREA", "LOCATION", "TOTAL SQ.FT.", "AVAILABILITY"],
      ];
    }
    if (medium === "3") {
      h = [
        [
          "SR NO",
          "ID NO",
          "STATION NAME",
          "TYPE",
          "WIDTH",
          "HEIGHT",
          "AVAILABILITY",
        ],
      ];
    }
    if (medium === "4") {
      h = [
        [
          "SR NO",
          "ID NO",
          "AREA",
          "LOCATION",
          "SIZE",
          "TOTAL NO. OF INDICATORES",
          "AVAILABILITY",
        ],
      ];
    }

    if (medium === "6") {
      h = [
        [
          "SR NO",
          "ID NO",
          "AREA",
          "LOCATION",
          "WIDTH",
          "HEIGHT",
          "TOTAL NO. OF PILLERS",
          "AVAILABILITY",
        ],
      ];
    }

    if (showRate !== "noRate") h[0].push("RATE");
    return h;
  };

  const getBodyData = () => {
    let data = [];
    let j = 1;
    let data2 = [];
    for (let i = 0; i < PPTdata.length; i++) {
      if (checkbox[i] === true) {
        data2.push(PPTdata[i]);
      }
    }
    // console.log(data2);
    for (let i = 0; i < data2.length; i++) {
      // console.log(data2[i], 508);
      let obj = {};
      if (medium === "1" || medium === "5") {
        // SR NO	ID NO	ZONE	CITY/AREA	LOCATION	MEDIA	TYPE	WIDTH	HEIGHT	AVAILABILITY	LONGITUDE	LATITUDE	RATE
        obj = {
          sr_no: j,
          id: data2[i].idno,
          zone: data2[i].zone_name,
          area: data2[i].area,
          location: data2[i].location,
          media: data2[i].media,
          type: data2[i].type,
          w: data2[i].width,
          h: data2[i].height,
          availability: data2[i].availability,
        };
        if (showLatitude !== "false") {
          // console.log("first", 475);
          obj = {
            ...obj,
            lat_long: `${data2[i].latitude} & ${data2[i].longitude}`,
          };
        }
        j += 1;
      }
      if (medium === "2") {
        obj = {
          sr_no: j,
          id: data2[i].idno,
          area: data2[i].area,
          location: data2[i].location,
          totalSqFt: data2[i].total_sq_ft,
          availability: data2[i].availability,
        };
        j += 1;
      }
      if (medium === "3") {
        obj = {
          sr_no: j,
          id: data2[i].idno,
          stationName: data2[i].station_name,
          type: data2[i].type,
          w: data2[i].width,
          h: data2[i].height,
          availability: data2[i].availability,
        };
        j += 1;
        delete obj.image;
      }
      if (medium === "4") {
        obj = {
          sr_no: j,
          id: data2[i].idno,
          area: data2[i].area,
          location: data2[i].location,
          size: data2[i].size,
          totalNoIndicators: data2[i].tot_no_of_indicators,
          availability: data2[i].availability,
        };
        j += 1;
      }
      if (medium === "6") {
        obj = {
          sr_no: j,
          id: data2[i].idno,
          area: data2[i].area,
          location: data2[i].location,
          width: data2[i].width,
          height: data2[i].height,
          no_of_piller: data2[i].no_of_piller,
          availability: data2[i].availability,
        };
        // "Area",
        //   "Location",
        //   "Width",
        //   "Height",
        //   "Total No. of PILLERS",
        j += 1;
      }
      // if (showRate) obj.rate = PPTdata[i].rate;
      // if (showRate !== "noRate") obj.rate = rateValueList[i];
      if (showRate !== "noRate") obj.rate = data2[i].rate;
      data.push(obj);
    }
    return data;
  };

  const getTerms = () => {
    let terms1 = [
      [" ", "Terms & Conditions:"],
      [1, "Flex Printing and Mounting Charges will be 20 Rs. Per Sq. Ft."],
    ];
    if (medium === "1") {
      terms1 = [
        [" ", "Terms & Conditions:"],
        [1, "Flex Printing Charges will be EXTRA."],
        [2, "Flex Fixing Charges will be EXTRA."],
      ];
    }
    if (medium === "3") {
      terms1 = [
        [" ", "Terms & Conditions:"],
        [1, "Flex Printing Charges will be EXTRA @Rs. 7/- Per Sq.Ft."],
        [2, "Flex Fixing Charges will be EXTRA @Rs. 3/- Per Sq.Ft."],
      ];
    }
    let m = 1;
    if (medium === "3" || medium === "1") m = 2;
    let terms2 = [
      [m + 1, "18% GST will be EXTRA."],
      [
        m + 2,
        "If the client requires Flex and wants it to be removed, an additional charge of Rs. 1/- per square feet will be applied.",
      ],
      [m + 3, "We do not accept or process any printing jobs after 6:00 PM."],
      [
        m + 4,
        "You will receive the installation photographs within 24 working hours.",
      ],
      [
        m + 5,
        "Photographs of the displayed advertisement will be available only after 48 working hours.",
      ],
      [
        m + 6,
        "Please be aware that the confirmation of the mentioned hoarding sites is subject to availability.",
      ],
      [
        m + 7,
        "We are not responsible for any misplacement or damage of the flex material.",
      ],
      [
        m + 8,
        "Kaushik Outdoors will not be held responsible for any damages caused by electrical problems resulting from AEC (Ahmedabad Electricity Company) or natural calamities.",
      ],
      [
        m + 9,
        "PAN (Permanent Account Number) and GSTIN (Goods and Services Tax Identification Number) are required at the time of booking for billing.",
      ],
      [
        m + 10,
        "We do not promote any Non Vegetarian / Eggetarian Campaign.",
      ],
      [
        m + 11,
        "We require a minimum notice period of 7 days for cancellations, as we cannot accept any kind of immediate cancellation.",
      ],
    ];
    let terms = [...terms1, ...terms2];
    return terms;
  };

  const exportExcel = async () => {
    dispatch(setLoadingTrue())
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    let jsonData = getBodyData();
    const rows = jsonData.map((item) => Object.values(item));
    // Add column headers and rows to the worksheet
    // worksheet.addRow(columns);
    worksheet.addRows(getHeading());
    rows.forEach((row) => {
      if (medium === "1" || medium === "5") {
        row[7] = Number(row[7]);
        row[8] = Number(row[8]);
      }
      if (medium === "2") {
        row[4] = Number(row[4]);
      }
      if (medium === "3" || medium === "6") {
        row[4] = Number(row[4]);
        row[5] = Number(row[5]);
      }
      if (medium === "4") {
        row[5] = Number(row[5]);
      }
      worksheet.addRow(row);
    });
    if (showLatitude !== "false") {
      let arr = ["LONGITUDE & LATITUDE"];
      rows.forEach((row) => arr.push(row[10]));
      arr.forEach((value, index) => {
        if (index !== 0 && value) {
          let cell = worksheet.getCell(index + 1, 11);
          cell.value = {
            text: value,
            hyperlink:
              "https://www.google.com/maps/place/" + value.replace(" & ", ","),
          };
          cell.font = {
            color: { argb: "000091" }, // Red color
          };
        }
      });
    }

    worksheet.getRow(1).font = { bold: true };
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          vertical: "center",
          horizontal: "left",
        };
        // cell.rul
      });
    });

    worksheet.columns.forEach((column) => {
      const lengths = column.values.map((v) => v.toString().length);
      const maxLength = Math.max(
        ...lengths.filter((v) => typeof v === "number")
      );
      column.width = maxLength + 2;
    });
    if (medium === "1" || medium === "5") {
      // console.log(worksheet.getColumnKey, 658);
      worksheet.getColumn(7).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(8).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(9).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(12).alignment = {
        horizontal: "center",
      };
    }
    if (medium === "2") {
      worksheet.getColumn(5).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(7).alignment = {
        horizontal: "center",
      };
    }

    if (medium === "3") {
      // console.log(worksheet.getColumnKey, 658);
      worksheet.getColumn(4).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(5).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(6).alignment = {
        horizontal: "center",
      };
      worksheet.getColumn(8).alignment = {
        horizontal: "center",
      };
    }

    let n = jsonData.length + 5;
    worksheet.addRows([[""], [""], [""]]);
    worksheet.addRows(getTerms());
    // Merge cells A20 to H20
    for (let i = n; i < n + 15; i++) {
      worksheet.mergeCells(`B${i}:L${i}`);
      worksheet.getCell(`B${i}`).alignment = {
        horizontal: "left",
      };
    }
    worksheet.getCell("B"+n).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "center",
      horizontal: "center",
    };
    worksheet.getColumn(1).alignment = {
      vertical: "center",
      horizontal: "center",
    };
    let siteName = "";
    MediumList.forEach((item) => {
      // console.log(typeof filter.medium, typeof item.id);
      if (item.id === medium) siteName = item.name;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const d1 = new Date();
    const d = d1.toString();
    a.download = `Shortlisted Sites ${siteName} ${d
      .slice(0, 24)
      .replace(/ /g, "_")}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);

    setTimeout(() => {
      dispatch(setLoadingFalse());
    }, 1000);
  };

  const generatePDF = async () => {
    dispatch(setLoadingTrue());
    setTimeout(() => {
      downloadPDF();
    }, 1000);
  };

  const downloadPDF = async () => {
    try {
      // var doc = new jsPDF("landscape", "px", "a4");
      let doc = await new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [640, 360],
      });
      // var img = new Image();
      // img.src = logo;
      // doc.addImage("https://scx2.b-cdn.net/gfx/news/2020/nature.jpg", "jpg", 0, 0, 650, 448);
      doc.addImage(Theme, "jpg", 0, 0, 640, 360);
      const d1 = new Date();
      const d = d1.toString();
      const date = `${d.slice(8, 10)} ${d.slice(4, 7)}, ${d1.getFullYear()}`;

      const showTime = d1.toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      doc.setTextColor('#FFFFFF')
      doc.text(540, 320, date);
      doc.text(540, 340, showTime);

      let data = [];
      for (let i = 0; i < PPTdata.length; i++) {
        if (checkbox[i] === true) {
          data.push(PPTdata[i]);
        }
      }
      // for (let i = 0; i < PPTdata.length; i++) {
      //   if (checkbox[i + 1] === true) {
      //     data.push(PPTdata[i]);
      //   }
      // }

      // Process PDF pages sequentially to avoid resource exhaustion  
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        console.log(`Processing PDF page ${i + 1} of ${data.length}`);
        
        doc.addPage();
        // const imageType = item.image.slice(-3);
        const imageType = item.image.split(".").pop();
        doc.addImage(whiteLayout, "jpg", 0, 0, 640, 360);
        let y1 = 5, y2 = 285
        if(showDataBelowImage !== "true"){
          y1 = 15
          y2 = 295
        }
        if (imageType === "svg") {
          doc.addImage(logo, "png", 70, y1+5, 480, y2+15);
          // doc.addImage(logo, "png", 70, 50, 480, 300);
        } else {
          doc.addImage(item.image, 'jpeg', 70, y1, 480, y2);
        }
        let locationText = `${item.idno} - ${item.location}`
          if(medium === "1" || medium === "5"){
            locationText =  `${locationText}, ${item.width} x ${item.height}, ${item.type}`
          }
        if ((medium === "1" || medium === "5") && showLatitude !== "false" && showDataBelowImage === "true") {
          // Draw table outline
          doc.rect(70, 290, 480, 60, "S");
          // Draw horizontal lines for rows
          doc.setFontSize(10)
          doc.line(70, 310, 550, 310);
          doc.line(70, 330, 550, 330);
          // Draw vertical line for columns
          doc.line(310, 310, 310, 350);
          // Set text color to white
          doc.setTextColor(255, 255, 255);
          // First row - merged cells (no vertical line in first row)
          doc.text(85, 305, locationText);
          doc.setFontSize(12)
          // Second row - two cells
          doc.text(85, 325, `Availability:     ${item.availability}`);
          doc.text(330, 325, `Rate:     ${showRate !== "noRate" ? item.rate : ""}`);
          // Third row - two cells
          doc.text(85, 345, `Lat & Long:`);
          doc.text(330, 345, `Note:`);
          
          // Add clickable coordinates below the table - keep this blue for visibility
          doc.setTextColor(0, 0, 150);
          doc.textWithLink(`${item.latitude} & ${item.longitude}`, 150, 345, {
            url: `https://www.google.com/maps/place/${item.latitude},${item.longitude}`,
          });
        } else if (showDataBelowImage === "true") {
          // Draw table outline
          doc.rect(70, 290, 480, 50, "S");
          // Draw horizontal line for rows
          doc.line(70, 310, 550, 310);
          // Draw vertical line for columns
          doc.line(310, 310, 310, 340);
          // Set text color to white
          doc.setTextColor(255, 255, 255);
          doc.setFontSize(10)

          // First row - merged cells (no vertical line in first row)
          doc.text(85, 305, locationText);
          // Second row - two cells
          doc.setFontSize(12)

          doc.text(85, 325, `Availability:     ${item.availability}`);
          doc.text(330, 325, `Rate:     ${showRate !== "noRate" ? item.rate : ""}`);
        }
        
        // Small delay between pages for large datasets
        if (data.length > 20 && i < data.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 10));
        }
      }
      doc.addPage();
      doc.addImage(termsImgPPT, "jpg", 0, 0, 640, 360);
      doc.addPage();
      doc.addImage(lastPPT, "jpg", 0, 0, 640, 360);
      
      // Set text color to white for user details
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(16);
      doc.text(
        325,
        180,
        `${user_details.first_name} ${user_details.last_name} | ${user_details.designation_name}`
      );      
      doc.setFontSize(14);
      doc.text(350, 200, user_details.mobile);
      doc.text(350, 220, user_details.email);

      // Add social media icons with clickable links
      doc.link(279, 277, 15, 15, {
        url: "https://www.facebook.com/kaushikoutdoors"
      });

      doc.link( 298, 277, 15, 150, {
        url: "https://www.linkedin.com/company/kaushik-outdoors/"
      });

      doc.link(344, 277, 15, 15, {
        url: "https://twitter.com/kaushikoutdoors"
      });

      doc.link(314, 277, 15, 15, {
        url: "https://www.instagram.com/kaushikoutdoors/"
      });

      doc.link(328, 277, 15, 15, {
        url: "https://www.youtube.com/@kaushikoutdoors1812"
      });

      doc.save(`Sites ${d.slice(0, 24).replace(/ /g, "_")}.pdf`);
      dispatch(setLoadingFalse());
      // setTimeout(() => {
      // }, 3000);
    } catch (error) {
      console.log(error, 777);
      setShowAlert({open: true, message:error.message})
      dispatch(setLoadingFalse());
      // reload after 1 second
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const generatePDFtable = () => {
    try{
      dispatch(setLoadingTrue());
      var doc = new jsPDF("landscape", "px", "a4");
      autoTable(doc, {
        theme: "grid",
        head: getHeading(),
        body: getBodyData().map((item) => Object.values(item)),
        styles: { halign: "center" },
      });
      autoTable(doc, {
        theme: "grid",
        head: [],
        body: getTerms(),
        styles: { margin: { top: 200 } },
        columnStyles: {
          0: { halign: "center", cellWidth: 40 },
        },
      });
      const d1 = new Date();
      const d = d1.toString();
      let siteName = "";
      MediumList.forEach((item) => {
        // console.log(typeof filter.medium, typeof item.id);
        if (item.id === medium) siteName = item.name;
      });
      doc.save(
        `Sites_table ${siteName} ${d.slice(0, 24).replace(/ /g, "_")}.pdf`
      );
      setTimeout(() => {
        dispatch(setLoadingFalse());
      }, 1000);
    } catch (error) {
      console.log(error);
      setShowAlert({open: true, message:error.message})
      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    let n = (page - 1) * 48;
    setPagePPTdata(PPTdata.slice(n, n + 48));
  }, [page, PPTdata]);

  const applyFilter = useCallback(async (filterObj) => {
    let rate = localStorage.getItem("ratePercentage");
    setShowRate(rate);
    let lat_long = localStorage.getItem("showLatitude");
    setShowLatitude(lat_long);
    let sortDataBy = localStorage.getItem("sortDataBy");
    dispatch(setLoadingTrue());
    myRef.current?.scrollIntoView();
    // window.scrollTo({ top: "900px", left: 0, behavior: 'smooth' });
    setMedium(filterObj.medium);
    try {
      let formData = new FormData();
      formData.append("token", routes.TOKEN);
      formData.append("session_token", user_details.session_token);
      let m = "";
      MediumList.forEach((i) => {
        if (i.id === filterObj.medium) m = i.name2;
      });
      formData.append("medium", m);
      let selected = [];
      for (let x in filterObj) {
        if (x !== "medium" && filterObj[x].length > 0) {
          let arr1 = filterObj[x].map((i) => i.value);
          if (arr1[0] === "*") arr1.shift();
          selected.push({
            name: x,
            value: JSON.stringify(arr1).slice(1, -1).replaceAll('"', "'"),
          });
          formData.append(
            `${x}`,
            JSON.stringify(arr1).slice(1, -1).replaceAll('"', "'")
          );
        }
      }
      const dataRes = await fetch(`${routes.API_URL}${routes.FILTER}`, {
        method: "POST",
        body: formData,
      });
      const json = await dataRes.json();
      if (json) {
        setShowResult(true);
        if (json.status_code === "1") {
          let arrObj1 = json.data;
          let totalPage = Math.ceil(Number(json.data_count) / 48);
          setTotal_page_count(totalPage);
          json.data.forEach((item, index) => {
            let arr1;
            arrObj1[index]["index_id"] = index;
            if (rate !== "noRate") {
              arrObj1[index]["rate"] = (item.rate * rate) / 100;
            } else {
              arrObj1[index]["rate"] = "";
            }
            if (item.lat_long && lat_long !== "false") {
              arr1 = item.lat_long.split("/").slice(-1)[0].split(",");
              arrObj1[index]["latitude"] = arr1[0];
              arrObj1[index]["longitude"] = arr1[1];
            } else {
              arrObj1[index]["latitude"] = "";
              arrObj1[index]["longitude"] = "";
            }
          });
          if(sortDataBy === "area"){
            // console.log("first", 984);
            arrObj1.sort((a, b) => a.area.localeCompare(b.area));
          }
          setPPTdata(arrObj1);
          setPage(1);
          if (totalPage > 1) {
            setPagePPTdata(arrObj1.slice(0, 48));
          } else {
            setPagePPTdata(arrObj1);
          }
          let obj2 = { 0: true };
          json.data.forEach((item, index) => {
            obj2[index] = true;
          });
          setCheckbox(obj2);
          myRef.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (json.status_code === "2") {
          localStorage.removeItem("user_details");
          localStorage.removeItem("filterObj");
          navigate("/login");
        }
      }
    } catch (error) {
      console.log(error);
      setPPTdata([]);
      setShowAlert({open: true, message:error.message})
    } finally{
      dispatch(setLoadingFalse());
    }
    // setShowFilter(false);
  }, [navigate, setShowAlert]);

  useEffect(() => {
    const filterObj = JSON.parse(localStorage.getItem("filterObj"));
    if (filterObj) {
      applyFilter(filterObj);
    }
  }, []);

  return (
    <div>
      <Header
        setOpenModal={setOpenModal}
        login={true}
        user_details={user_details}
      />
      {loading ? (
        <Loader isLoading={loading}/>
      ) : (
        <div id="filterPage">
          <FilterSelection
            applyFilter={applyFilter}
            user_details={user_details}
            setShowAlert={setShowAlert}
            setShowResult={setShowResult}
          />
          <div ref={myRef}>
             { showResult && (
                <div>
                  <div className="total-result">
                    <Row className="p-3">
                      <Col sm={6} md={3}>
                        <b>Total Results: </b> &nbsp; {PPTdata.length}
                      </Col>
                      <Col sm={6} md={3}>
                        <b> Selected: </b>&nbsp;
                        {Object.values(checkbox).reduce(
                          (total, n) => total + Number(n),
                          0
                        )}
                      </Col>
                      <Col sm={6} md={3}>
                        {" "}
                        <b> Medium: </b>&nbsp;
                        {MediumList.filter((i) => i.id === medium)[0]["name2"]}
                      </Col>
                      <Col sm={6} md={3}>
                        {" "}
                        <b>Rate(%): </b>&nbsp; {showRate}{" "}
                      </Col>
                    </Row>
                    
                    {/* Progress indicator for large image processing */}
                    {processingProgress.isProcessing && (
                      <div className="progress-container" style={{ 
                        padding: '15px', 
                        background: '#f8f9fa', 
                        borderRadius: '5px', 
                        margin: '10px 0',
                        textAlign: 'center' 
                      }}>
                        <div style={{ marginBottom: '10px', fontSize: '14px', fontWeight: 'bold' }}>
                          Processing Images: {processingProgress.current} of {processingProgress.total}
                        </div>
                        <div style={{ 
                          width: '100%', 
                          backgroundColor: '#e0e0e0', 
                          borderRadius: '10px', 
                          height: '20px',
                          overflow: 'hidden'
                        }}>
                          <div style={{ 
                            width: `${(processingProgress.current / processingProgress.total) * 100}%`, 
                            backgroundColor: '#28a745', 
                            height: '100%',
                            borderRadius: '10px',
                            transition: 'width 0.3s ease'
                          }}></div>
                        </div>
                        <div style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                          Please wait, this may take a few minutes for large datasets...
                        </div>
                      </div>
                    )}
                    
                    <div className="download-button">
                      <Button color="success" onClick={() => generatePPT()} disabled={processingProgress.isProcessing}>
                        <FaDownload />
                        <span>PPT</span>
                        {/* &nbsp; {loaderFor.ppt && (
                  <TailSpin color="#fff" height={20} width={20} />
                )} */}
                      </Button>

                      <Button color="success" onClick={() => generatePDF()} disabled={processingProgress.isProcessing}>
                        <FaDownload />
                        <span> PDF (PPT)</span>
                      </Button>

                      <Button color="success" onClick={() => exportExcel()} disabled={processingProgress.isProcessing}>
                        <FaDownload />
                        <span>Excel</span>
                      </Button>

                      <Button
                        color="success"
                        onClick={() => generatePDFtable()}
                        disabled={processingProgress.isProcessing}
                      >
                        <FaDownload />
                        <span> PDF (Excel)</span>
                      </Button>
                    </div>
                  </div>
                  {pagePPTdata.length > 0 ? (
                    <Row>
                      {pagePPTdata.map((item, index) => (
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          xl={3}
                          key={index}
                          className="p-0"
                        >
                          <div className="card">
                            <input
                              type="checkbox"
                              name={item.index_id}
                              className="tableCheckbox"
                              checked={checkbox[item.index_id]}
                              onChange={() => handleCheck(item.index_id)}
                            />

                            <img
                              src={item.image}
                              width="270px"
                              height="180px"
                              alt="img1"
                              className="tableIMG"
                              onClick={() => {
                                setImgURL(item.image);
                                setImgModal(true);
                              }}
                            />
                            <div style={{ minHeight: "260px" }}>
                              <div>
                                <p
                                  className={
                                    checkbox[item.index_id]
                                      ? "card-id-btn active-card-id"
                                      : "card-id-btn"
                                  }
                                  onClick={() => handleCheck(item.index_id)}
                                >
                                  {item.idno}
                                </p>

                                {medium === "1" && (
                                  <Row>
                                    <Col xs={3} className="label-text">
                                      <b>Zone :</b>
                                    </Col>
                                    <Col className="text2">
                                      {" "}
                                      {item.zone_name}
                                    </Col>
                                  </Row>
                                )}
                                {medium !== "3" && (
                                  <Row>
                                    <Col xs={3} className="label-text">
                                      <b>Area :</b>
                                    </Col>
                                    <Col className="text2"> {item.area}</Col>
                                  </Row>
                                )}

                                {/* {medium === "1" && ()} */}
                                {medium !== "2" && medium !== "3" && (
                                  <Row>
                                    <b>Location :</b>
                                    <span>{item.location}</span>
                                  </Row>
                                )}

                                {medium === "2" && (
                                  <Row>
                                    <Col>
                                      <b>Total Sq.Ft. :</b>&emsp;
                                      <span className="text2">
                                        {item.total_sq_ft}
                                      </span>
                                    </Col>
                                  </Row>
                                )}
                                {medium === "2" && (
                                  <Row>
                                    <Col>
                                      <b>Location :</b>&emsp;
                                      <span className="text2">
                                        {item.location}
                                      </span>
                                    </Col>
                                  </Row>
                                )}

                                {medium === "3" && (
                                  <Row>
                                    <Col>
                                      <b>Station Name :</b>&emsp;
                                      <span className="text2">
                                        {item.station_name}
                                      </span>
                                    </Col>
                                  </Row>
                                )}
                                {medium === "3" && (
                                  <Row>
                                    <Col>
                                      <b>Type :</b>&emsp;
                                      <span className="text2">{item.type}</span>
                                    </Col>
                                  </Row>
                                )}
                                {medium === "4" && (
                                  <Row>
                                    <Col>
                                      <b>Size :</b>&emsp;
                                      <span className="text2">{item.size}</span>
                                    </Col>
                                  </Row>
                                )}
                                {medium === "4" && (
                                  <Row>
                                    <Col>
                                      <b>TOTAL NO. OF INDICATORES :</b>&emsp;
                                      <span className="text2">
                                        {item.tot_no_of_indicators}
                                      </span>
                                    </Col>
                                  </Row>
                                )}
                                {medium === "6" && (
                                  <Row>
                                    <Col>
                                      <b> Total No. of Pillers:</b>&emsp;
                                      <span className="text2">
                                        {item.no_of_piller}
                                      </span>
                                    </Col>
                                  </Row>
                                )}

                                {(medium === "1" ||
                                  medium === "5" ||
                                  medium === "6") && (
                                  <Row>
                                    <Col sm={6}>
                                      <b>Media :</b>
                                      &nbsp;
                                      <span className="text2">
                                        {item.media}
                                      </span>
                                    </Col>
                                    <Col sm={6}>
                                      &nbsp;<b>Type :</b> &nbsp;
                                      <span className="text2"></span>
                                      {item.type}
                                    </Col>
                                  </Row>
                                )}
                                {medium !== "2" && medium !== "4" && (
                                  <Row>
                                    <Col sm={6}>
                                      <b>Width :</b>
                                      &nbsp;{" "}
                                      <span className="text2">
                                        {item.width}
                                      </span>
                                    </Col>
                                    <Col sm={6}>
                                      &nbsp;<b>Height :</b> &nbsp;
                                      <span className="text2">
                                        {item.height}
                                      </span>
                                    </Col>
                                  </Row>
                                )}

                                <Row>
                                  <Col>
                                    <b>Availability :</b>&emsp;
                                    <span className="text2">
                                      {item.availability}
                                    </span>
                                  </Col>
                                </Row>

                                {showRate !== "noRate" && (
                                  <Col sm={6}>
                                    <b>Rate :</b>
                                    {/* &nbsp; <span className="text2">{item.rate}</span> */}
                                    &nbsp;{" "}
                                    <span className="text2">{item.rate}</span>
                                  </Col>
                                )}

                                {showLatitude !== "false" &&
                                  (medium === "1" ||
                                    medium === "5" ||
                                    medium === "6") && (
                                    <Row>
                                      <Col sm={6}>
                                        <b>Latitude and Longitude :</b>
                                      </Col>
                                      <Col sm={6}>
                                        <a
                                          href={item.lat_long}
                                          rel="noreferrer"
                                          target="_blank"
                                        >
                                          {
                                            item.lat_long
                                              .split("/")
                                              .slice(-1)[0]
                                              .split(",")[0]
                                          }{" "}
                                          &{" "}
                                          {
                                            item.lat_long
                                              .split("/")
                                              .slice(-1)[0]
                                              .split(",")[1]
                                          }
                                        </a>
                                      </Col>
                                    </Row>
                                  )}
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <div className="text-center mt-4">No data found</div>
                  )}

                  {total_page_count > 1 && (
                    <div className="filter-pagination">
                      <Pagination
                        count={total_page_count}
                        page={page}
                        onChange={(event, value) => {
                          setPage(value);
                        }}
                      />
                    </div>
                  )}
                  <div className="download-button pt-3">
                    <Button color="success" onClick={() => generatePPT()} disabled={processingProgress.isProcessing}>
                      <FaDownload />
                      <span>PPT</span>
                      {/* &nbsp; {loaderFor.ppt && (
                  <TailSpin color="#fff" height={20} width={20} />
                )} */}
                    </Button>

                    <Button color="success" onClick={() => generatePDF()} disabled={processingProgress.isProcessing}>
                      <FaDownload />
                      <span> PDF (PPT)</span>
                    </Button>

                    <Button color="success" onClick={() => exportExcel()} disabled={processingProgress.isProcessing}>
                      <FaDownload />
                      <span>Excel</span>
                    </Button>

                    <Button color="success" onClick={() => generatePDFtable()} disabled={processingProgress.isProcessing}>
                      <FaDownload />
                      <span> PDF (Excel)</span>
                    </Button>
                  </div>
                </div>
              )}
          </div>
          {imgModal && (
            <Modal isOpen={imgModal} toggle={() => setImgModal(false)} centered size="lg">
              <ModalBody className="p-0">
                <img
                  src={imgURL}
                  alt="Preview"
                  style={{ width: "100%", height: "auto" }}
                  onClick={() => setImgModal(false)}
                />
              </ModalBody>
            </Modal>
          )}
        </div>
      )}
    </div>
  );
}
